import { render, staticRenderFns } from "./modalPriorAuthorization.vue?vue&type=template&id=4b1b2b21&"
import script from "./modalPriorAuthorization.vue?vue&type=script&lang=js&"
export * from "./modalPriorAuthorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports